import React from 'react';
import CreateOrder from './actions/CreateOrder';
import CreateTradingAccount from './actions/CreateTradingAccount';
import CreateUser from './actions/CreateUser';
import UpdateUser from './actions/UpdateUser';
import ChangeUserStatus from './actions/ChangeUserStatus';
import ChangeUsersGroup from './actions/ChangeUsersGroup';
import UpdateOrder from './actions/UpdateOrder';
import CreateWithdrawal from './actions/CreateWithdrawal';
import AddBankAccount from './actions/AddBankAccount';
import DeleteBankAccount from './actions/DeleteBankAccount';
import DeleteSavedCard from './actions/DeleteSavedCard';
import UploadDocument from './actions/UploadDocument';
import CreateReserveAccount from './actions/CreateReserveAccount';
import UpdateReserveAccountInstant from './actions/UpdateReserveAccountInstant';
import KYCDocument from './actions/KYCDocument';
import CreateExchangeRate from "./actions/CreateExchangeRate";
import DeleteExchangeRate from "./actions/DeleteExchangeRate";
import UpdateExchangeRate from "./actions/UpdateExchangeRate";
import ConfirmKYC from "./actions/ConfirmKYC";
import CreateBank from "./actions/CreateBank";
import UpdateBank from "./actions/UpdateBank";
import CancelOrder from "./actions/CancelOrder";
import PaymentAction from "./actions/PaymentAction";
import AccountMetaAction from './actions/AccountMetaAction';
import UpdateSubscription from './actions/UpdateSubscription';
import CreateSubscription from './actions/CreateSubscription';
import UpdateGiftCard from './actions/UpdateGiftCard';
import CreateGiftCard from './actions/CreateGiftCard';
import DeclineKYC from './actions/DeclineKYC';
import UpdateInstrument from './actions/UpdateInstrument';
import TransactionAction from './actions/TransactionAction';
import ResolveTransactionAction from './actions/ResolveTransactionAction';



const ViewAction = props => {

    /* Pending Actions Modal object switch */

    return  ({
                "create_user": <CreateUser {...props} />,
                "update_user": <UpdateUser {...props} />,
                "change_user_status": <ChangeUserStatus {...props} />,
                "change_user_group": <ChangeUsersGroup {...props} />,
                "create_trading_account": <CreateTradingAccount {...props} />,
                "create_withdrawal": <CreateWithdrawal {...props} />,
                "add_bank_account": <AddBankAccount {...props} />,
                "delete_bank_account": <DeleteBankAccount {...props} />,
                "delete_saved_card": <DeleteSavedCard {...props} />,
                "upload_document": <UploadDocument {...props} />,
                "create_reserve_account": <CreateReserveAccount {...props} />,
                "update_reserve_account_instant": <UpdateReserveAccountInstant {...props} />,
                "update_document_field": <KYCDocument {...props} />,
                "approve_document": <KYCDocument {...props} />,
                "reject_document": <KYCDocument {...props} />,
                "update_kyc": <UpdateUser {...props} />,
                "confirm_kyc": <ConfirmKYC {...props} />,
                "decline_kyc": <DeclineKYC {...props} />,
                "reject_kyc": <DeclineKYC {...props} />,
                "create_bank": <CreateBank {...props} />,
                "update_bank": <UpdateBank {...props} />,
                "delete_bank": <UpdateBank {...props} />,
                "create_exchange_rate": <CreateExchangeRate {...props} />,
                "delete_exchange_rate": <DeleteExchangeRate {...props} />,
                "update_exchange_rate": <UpdateExchangeRate {...props} />,
                "create_order": <CreateOrder {...props} />,
                "update_order": <UpdateOrder  {...props} />,
                "cancel_order": <CancelOrder {...props} />,
                "update_payment": <PaymentAction {...props} />,
                "approve_withdrawal": <PaymentAction {...props} />,
                "approve_deposit": <PaymentAction {...props} />,
                "update_account_meta": <AccountMetaAction {...props} />,
                "create_subscription": <CreateSubscription {...props} />,
                "update_subscription": <UpdateSubscription {...props} />,
                "renew_subscription": <UpdateSubscription {...props} />,
                "cancel_subscription": <UpdateSubscription {...props} />,
                "cancel_gift_card": <UpdateGiftCard {...props} />,
                "update_gift_card": <UpdateGiftCard {...props} />,
                "create_gift_card": <CreateGiftCard {...props} />,
                "update_instrument": <UpdateInstrument {...props} />,
                "add_transaction": <TransactionAction {...props} />,
                "resolve_transaction": <ResolveTransactionAction {...props} />,
            })[props.action?.method] ?? null;

}

export default ViewAction;